import React from 'react';
import { Checkbox, FormGroup, FormControl } from 'react-bootstrap';
import { find } from 'lodash';
import { replaceExpression, makeFirstCharUppercase } from '../utils';

import IconTooltip from './IconTooltip';
import Collaboration from './Collaboration';

import { CollaboratorsContext } from '../context/CollaboratorsContext';
import CheckmarkQuestionAnswered from './CheckmarkQuestionAnswered';
import * as answerService from "../services/answer-service";

export default class CheckBoxQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTextBox: false,
      allComments: [],
      comment: ''
    };
    this.handleTexAreaChange = this.handleTexAreaChange.bind(this);
  }

  getValue(optionId) {
    const value = find(this.props.state, s => s.optionId === optionId);
    return value ? value.booleanValue : false;
  }

  getOriginalValue(optionId) {
    let value = undefined;

    if (this.props.originalState) {
      value = find(this.props.originalState, s => s.optionId === optionId);
    }
    return value ? value.booleanValue : false;
  }

  // Fetch comments when component mounts
  componentDidMount() {
    var scanId = (this.props.analyse === true)
        ? this.props.originalState[0].scanId
        : (this.props.state && this.props.state[0] ? this.props.state[0].scanId : null);

    if (scanId) {
      answerService.getComments(scanId)
          .then((allComments) => {
            this.setState({ allComments });
          })
          .catch((error) => {
            console.error("Error fetching comments:", error);
          });
    }
  }

  // Get explanation for the specific question
  getExplanationValue(data) {
    const { allComments } = this.state;
    if (!allComments) return '';

    const commentEntry = allComments.find((comment) => comment.questionId === data.id);
    return commentEntry ? commentEntry.comment : '';
  }

  // Update the explanation value when the textarea changes
  handleTexAreaChange(e, data) {
    const updatedComment = e.target.value;

    // Update local state to reflect the change immediately
    this.setState(prevState => {
      const updatedComments = prevState.allComments.map(comment =>
          comment.questionId === data.id
              ? { ...comment, comment: updatedComment }
              : comment
      );

      return {
        allComments: updatedComments,
        comment: updatedComment,
      };
    });

    // Save the updated comment to the backend
    answerService.updateAnswer({
      scanId: this.props.state[0].scanId,
      questionId: data.id,
      comment: updatedComment
    }).catch(error => {
      console.error("Error updating comment:", error);
    });
  }

  obtainAnsweredCheckDOM(optionIds) {
    let questionHasAnswer = false;

    optionIds.forEach(id => {
      const checked = this.getValue(id);
      if (checked === true) questionHasAnswer = true;
    });

    return (
        <CheckmarkQuestionAnswered checked={questionHasAnswer} />
    );
  }

  render() {
    const { data, completed, onChange, answermap, isIntroQuestions } = this.props;
    const optionIds = data.options.map(option => option.id);

    return (
        <div className="question-group type-checkbox row">
          <div className="col">
            <form>
            <span>{replaceExpression(data.questionText, answermap)}
              <div className="indicator-container">
                <IconTooltip text={replaceExpression(data.explanation, answermap)} icon="far fa-info-circle" />
                {this.obtainAnsweredCheckDOM(optionIds)}
              </div>
            </span>
              <FormGroup>
                {data.options.map(option => (
                    <Checkbox
                        className={this.getOriginalValue(option.id) ? 'original' : ''}
                        name={data.questionNumber}
                        value={option.id}
                        key={option.id}
                        disabled={completed}
                        checked={this.getValue(option.id)}
                        onChange={e => onChange(e, optionIds, true)}
                    >
                      <span className="text">{makeFirstCharUppercase(replaceExpression(option.optionText, answermap))}</span>
                    </Checkbox>
                ))}
              </FormGroup>
              {
                  !this.props.feedback &&
                  <div className="free-text">
                    <span>Toelichting:</span>
                    <br />
                    <FormControl
                        componentClass="textarea"
                        disabled={completed || this.props.analyse}
                        value={this.state.comment || this.getExplanationValue(data)}
                        onChange={(e) => this.handleTexAreaChange(e, data)} 
                    />
                  </div>
              }

            </form>
          </div>
          {!isIntroQuestions &&
              <CollaboratorsContext.Consumer>
                {context => (
                    <Collaboration
                        data={data}
                        answermap={answermap}
                        collaborators={context.state.collaborators}
                        scanId={context.state.scanId}
                    />
                )}
              </CollaboratorsContext.Consumer>}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckBoxQuestion.js